<div class="app-layout" [ngClass]="{'mask-entity-names': publisherId && featureToggle?.MaskDemoData}">

  <section class="grid-layout" [ngClass]="{'collapsed': isCollapsed}">

    <aside class="aside">
      <app-unruly-navigation #unrulyNavigation
        [isCollapsed]="isCollapsed"
        (itemAction)="onItemAction($event)"></app-unruly-navigation>
    </aside>

    <!-- <app-icon [icon]="'union'"></app-icon> -->
    <fa-icon icon="arrow-alt-circle-left" class="collapse-aside-btn" (click)="onCollapseToggle()"></fa-icon>

    <header class="main-header">
      <app-breadcrumbs *ngIf="isBreadcrumbsVisible()"></app-breadcrumbs>
      <app-header-actions [headerActions]="headerActionsConfigs" (itemAction)="onItemAction($event)" ></app-header-actions>
    </header>

    <main class="portalRouterOutletWrapper">
      <!-- Spearad iframe -->
      <iframe data-hj-allow-iframe="true" title="spearad-iframe" *ngIf="hasNavigationPermission('publisherDeal')" #spearadIframeEl
              [ngClass]="{'iframeVisible': isIframeVisible()}"></iframe>
      <app-spearad-error *ngIf="isSpearadErrorVisible()"></app-spearad-error>
      <app-notfound *ngIf="!isRouteValid"></app-notfound>
      <!-- router-outlet -->
      <div *ngIf="isRouterOutletVisible()" class="padding-inline-1" [ngClass]="{'padding-top-small': currentContext !== 'spearad' }">
        <router-outlet></router-outlet>
      </div>
    </main>

    <!-- CTRL Global Search - overlays main & footer when open -->
    <div class="global-search" *ngIf="isGlobalSearchOpen" [ngClass]="{'open': isGlobalSearchOpen}">
      <app-global-search
        [isOpen]="isGlobalSearchOpen"
        [layout]="publisherId ? 'external' : 'internal'"
        (clickOutside)="isGlobalSearchOpen = false">
      </app-global-search>
    </div>

    <app-footer></app-footer>
  </section>
</div>
